<template>
  <div class="panel-group d-flex" :style="formType === 'process' ? 'padding-right: 40px; width: 100%' : 'width:100%'">
    <div class="d-flex" :class="{
      'err-msg': isInvalid,
      'col-6': formType === 'process',
      'col-4': formType !== 'process' && formType !== 'fileAccess',
      'col-5': formType === 'fileAccess'
    }" style="padding-left: 0 !important;">
      <label class="form-label"> {{ label }} <Tooltip :text="tooltip || label"><i v-if="showInfo"
            class="ag-icon ag-icon_table_info small info-icon" /></Tooltip></label>

    </div>
    <div :class="{
      'col-6': formType === 'process',
      'col-8': formType !== 'process' && formType !== 'fileAccess',
      'col-7': formType === 'fileAccess'
    }" :style="formType === 'process' ? 'padding-left: 0' : ''">
      <Dropdown v-model="internalValue" :editable="label === 'Folder Map'"
        :options="label === 'Folder Map' ? filteredOptions : options" :optionLabel="optionLabel"
        :optionValue="optionValue" class="base-dropdown" :placeholder="placeholder"
        :appendTo="body" :style="inputType === 'fileTypePolicy' ? { width: '100%' } : { width: 'auto' }"
        :panelStyle="label === 'Folder Map' && inputType !== 'fileTypePolicy' ? { maxHeight: '70vh', overflow: 'auto' } : null"
        :scrollHeight="label === 'Folder Map' && inputType !== 'fileTypePolicy' ? '70vh' : '200px'"
        :pt="label === 'Folder Map' ? { input: { onInput: onDropdownInput } } : undefined"
        :disabled="disabled">
        <template #option="slotProps">
          <Tooltip v-if="label === 'Folder Map'" :text="slotProps.option.mapPath" >
            <div style="position: relative; width: 100%;">
              {{ slotProps.option.label }}
            </div>
          </Tooltip>
          <div v-else style="position: relative; width: 100%;">
            {{ slotProps.option.label }}
          </div>
        </template>
      </Dropdown>
    </div>

  </div>
</template>

<script setup>
import { defineProps, defineEmits, computed, ref } from 'vue'
import Dropdown from 'primevue/dropdown'
import Tooltip from './tooltip.vue'

const props = defineProps({
  modelValue: [String, Number],
  label: String,
  options: Array,
  optionLabel: {
    type: String,
    default: 'label'
  },
  optionValue: {
    type: String,
    default: 'value'
  },
  placeholder: String,
  showInfo: {
    type: Boolean,
    default: true
  },
  formType: {
    type: String,
  },
  tooltip: {
    type: String,
    default: ''
  },
  disabled: {
    type: Boolean,
    default: false
  },
  inputType: {
    type: String,
    default: ''
  }
})
const emit = defineEmits(['update:modelValue'])
const internalValue = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
})

const searchText = ref('')
const filteredOptions = computed(() => {
  if (props.label !== 'Folder Map') return props.options || []
  const q = (searchText.value || '').toLowerCase()
  const list = Array.isArray(props.options) ? props.options : []
  if (!q) return list
  return list.filter((opt) => {
    const lbl = (opt?.[props.optionLabel] ?? '').toString().toLowerCase()
    // const mp = (opt?.mapPath ?? '').toString().toLowerCase()
    return lbl.includes(q);
  })
})

function onDropdownInput(e) {
  const val = e && e.target ? e.target.value : ''
  searchText.value = val
}
</script>

<style scoped>
.panel-group {
  font-size: 0.8rem !important;
  width: 100%;
}

.form-label {
  color: #164B6C;
  font-weight: bold;
  margin-left: 0;
  display: inline-flex;
  align-items: center;
}

.info-icon {
  margin-left: 6px;
  display: inline-flex;
  align-items: center;
}

.base-dropdown {
  font-size: 0.8rem !important;
  width: inherit;
  height: 30px;
  align-items: center;
}

.tooltip-sm .p-tooltip-text {
  font-size: 0.8rem !important;
  line-height: 1.2;
  padding: 4px 8px;
}

::v-deep(.p-inputtext) {
  font-size: 0.8rem !important;
  padding: 0.25rem 0.5rem;
}
::v-deep(.p-dropdown-trigger) {
  justify-content: end;
  margin-right: 0.5rem;
}
</style>
